import { Link } from 'react-router-dom';
import { Typography } from 'seagull';
import { routes } from "../../../../constants";
import { jsx as _jsx } from "react/jsx-runtime";
const VendorNameLink = _ref => {
  let {
    testid,
    vendorName,
    relationshipID
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    as: Link,
    to: routes.agreement(relationshipID),
    "data-testid": testid,
    variant: "paragraph1",
    noWrap: true,
    ellipsis: true,
    children: vendorName
  });
};
export default VendorNameLink;